function disableSubmitButton() {
    const submitButton: HTMLInputElement = document.getElementById("login-submit") as HTMLInputElement
    submitButton.disabled = true;
}

function enableSubmitButton() {
    const submitButton: HTMLInputElement = document.getElementById("login-submit") as HTMLInputElement
    submitButton.disabled = false;
}

$(() => {
    if (typeof(hcaptcha) === "undefined")
        return

    const siteKey = $(".h-captcha").data("siteKey") as string
    const options: ConfigRender = {
        callback: enableSubmitButton,
        "expired-callback": disableSubmitButton,
        sitekey: siteKey,
    }
    hcaptcha.render("hcaptcha", options)
})
